import React from 'react'

import './filter-bar.scss'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import closeIcon from '../../assets/icons/close.svg'

import Icon from '../icon'
import LinkButton from '../link-button'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    filters?: React.ReactNode
    filtersLabel?: React.ReactNode
    searchBar?: React.ReactNode
    onClearAll?: React.MouseEventHandler
    clearAllLabel?: string
  }
>

const FilterBar = ({
  className,
  filtersLabel,
  filters,
  searchBar,
  onClearAll,
  clearAllLabel,
  ...props
}: Props) => (
  <div {...props} className={cn('FilterBar', {}, className)}>
    <div className="FilterBar__filters">
      <div className="FilterBar__label">{filtersLabel}</div>
      {filters}
      {onClearAll && clearAllLabel && (
        <LinkButton
          appearance="minor"
          icon={<Icon source={closeIcon} />}
          onClick={event => onClearAll(event)}
        >
          {clearAllLabel}
        </LinkButton>
      )}
    </div>
    {!!searchBar && <div className="FilterBar__searchBar">{searchBar}</div>}
  </div>
)

export default FilterBar
